import { render, staticRenderFns } from "./clickView.vue?vue&type=template&id=903d8588&scoped=true"
import script from "./clickView.vue?vue&type=script&lang=js"
export * from "./clickView.vue?vue&type=script&lang=js"
import style0 from "./clickView.vue?vue&type=style&index=0&id=903d8588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903d8588",
  null
  
)

export default component.exports